// ImpactOperatorTable.js

import { useMemo } from 'react';

const ImpactOperatorTable = ({ assessments, fieldOptions }) => {
  // Используем useMemo для мемоизации данных таблицы
  const tableData = useMemo(() => {
    return assessments;
  }, [assessments]);

  // Вычисляем общее количество ошибок
  const totalErrors = useMemo(() => {
    return tableData.reduce((sum, assessment) => sum + assessment.zero_count, 0);
  }, [tableData]);

  if (!tableData || tableData.length === 0) {
    return (
      <div className="table-wrapper">
        <h3>Операторы по уровням impact</h3>
        <table className="stats-table">
          <thead>
            <tr>
              <th>Оператор</th>
              <th>Номер</th>
              <th>Комментарий</th>
              <th>C/M</th>
              <th>Проверяющий</th>
              <th>Количество ошибок</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ textAlign: 'center', textWidth: 'bold', fontSize: '20px' }}>
              {"Нет записей"}
            </tr>
          </tbody>
          {/*<tfoot>*/}
          {/*  <tr>*/}
          {/*    <td>Grand Total</td>*/}
          {/*    <td></td>*/}
          {/*    <td></td>*/}
          {/*    <td></td>*/}
          {/*    <td></td>*/}
          {/*    <td>0</td>*/}
          {/*  </tr>*/}
          {/*</tfoot>*/}
        </table>
      </div>
    );
  }

  return (
    <div className="table-wrapper">
      <h3>Операторы по уровням impact</h3>
      <table className="stats-table">
        <thead>
          <tr>
            <th>Оператор</th>
            <th>Номер</th>
            <th>Комментарий</th>
            <th>C/M</th>
            <th>Проверяющий</th>
            <th>Количество ошибок</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map(assessment => (
            <tr key={assessment.id || assessment.agent_name}>
              <td>{assessment.agent_name}</td>
              <td>{assessment.srq}</td>
              <td>{assessment.comment}</td>
              <td>{assessment.srq}</td>
              <td>{(assessment.assessor.name && assessment.assessor.surname) ? assessment.assessor.name + ' ' + assessment.assessor.surname : assessment.assessor.username}</td>
              <td>{assessment.zero_count}</td>
            </tr>
          ))}
        </tbody>
        {/*<tfoot>*/}
        {/*  <tr>*/}
        {/*    <td>Grand Total</td>*/}
        {/*    <td></td>*/}
        {/*    <td></td>*/}
        {/*    <td></td>*/}
        {/*    <td></td>*/}
        {/*    <td>{totalErrors}</td>*/}
        {/*  </tr>*/}
        {/*</tfoot>*/}
      </table>
    </div>
  );
};

export default ImpactOperatorTable;